import { VehicleStatus } from '@repo/shared'
import { Badge } from '@repo/ui'
import { useTranslation } from 'react-i18next'

import type { ComponentProps } from 'react'

/** Badge variant per vehicle lifecycle status. */
const variantByStatus: Record<string, ComponentProps<typeof Badge>['variant']> =
  {
    [VehicleStatus.Active]: 'success',
    [VehicleStatus.Maintenance]: 'warning',
    [VehicleStatus.OutOfService]: 'secondary',
  }

type Props = {
  /** `VehicleStatus`; accepts string for API responses typed as a string union. */
  status: VehicleStatus | string
}

/**
 * Single source for the vehicle lifecycle status badge — enum-driven variant +
 * translated label (`vehicles:statusLabels.*`). Reuse everywhere a vehicle
 * status is shown so color and wording stay consistent.
 */
export function VehicleStatusBadge({ status }: Props) {
  const { t } = useTranslation('vehicles')

  return (
    <Badge variant={variantByStatus[status] ?? 'secondary'}>
      {t(`statusLabels.${status as VehicleStatus}`)}
    </Badge>
  )
}
